import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import * as Yup from 'yup';

import useTeamCreate from '../../../../hooks/useTeamCreate';
import useTeamUpdate from '../../../../hooks/useTeamUpdate';
import { SPECIAL_OFFER_PRICE } from '../../../../utils/backend-api/subscribe';
import { Team } from '../../../../utils/backend-api/teams';
import { Button } from '../../../BaseUI';
import { TextField } from '../../../FormFields';
import FormErrors from '../../../shared/FormErrors';
import SettingsHeading from '../SettingsHeading';

type FormValuesType = {
  name: string;
};

const validationSchema = () =>
  Yup.object({
    name: Yup.string().required('A name is required'),
  });

export default function NameForm({ team }: { team: Team }) {
  const { updateTeamAsync } = useTeamUpdate();
  const { createTeamAsync } = useTeamCreate();
  const [errors, setErrors] = useState([]);

  const initialValues: FormValuesType = {
    name: team?.name || '',
  };

  const onSubmit = async (values: FormValuesType) => {
    setErrors([]);
    let resp;
    if (team) {
      resp = await updateTeamAsync({
        name: values.name,
      });
    } else {
      resp = await createTeamAsync({
        name: values.name,
      });
    }
    if (resp.errors) setErrors(resp.errors);
  };

  return (
    <div data-test="team-settings-name">
      <SettingsHeading title="The Information For Your Team">
        Share The Information with your colleagues and make everyone smarter — Add additional
        accounts for ${SPECIAL_OFFER_PRICE} a year per person.
      </SettingsHeading>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
        enableReinitialize={true}
      >
        {({ isSubmitting, isValid, dirty }) => (
          <Form>
            <TextField name="name" label="Team Name" placeholder="Enter team name" />
            <FormErrors errors={errors} />
            <Button
              variant="primary"
              className="mt2"
              type="submit"
              disabled={(!isValid && dirty) || isSubmitting}
            >
              Save
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
}
